import ExportReports from './ExportReports';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { APIKeyData, ISelfRegistration } from '@stores/interfaces';
import OpenAiSettings from './OpenAi';
import InviteCodeSettings from './InviteCode';
import { useEffect, useState } from 'react';
import './style.css';
import { useTypedDispatch, useTypedSelector } from '@stores/index';
import Features from './Features';
import { ACTIVETAB, USER_ROLES } from '@stores/constants';
import Templates from './Templates';
import { getbandwidth, getSelfRegistration, getSettingApiKey } from '@stores/settings/setings';
import ThemeSelector from '@pages/Themes/ThemeSelector';
import { useAdminMenuConstants } from '@atoms/AdminMenu/AdminMenuLists';
import { setActiveTab as setReduxActiveTab } from '@stores/aiAssistant/aiAssistant';
import BandwidthMode from './BandwidthMode';
import ContentManager from './ContentManager';
import SelfRegistration from './SelfRegistration';

const Settings = () => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState(ACTIVETAB.OPENAI);
	const user = useTypedSelector(state => state.user);
	const isSuperAdmin = user?.profile?.role === USER_ROLES.SUPER_ADMIN;
	const dispatch = useTypedDispatch();
	const [settingData, setSettingData] = useState<APIKeyData | undefined>(
		undefined,
	);
	const [inviteCode, setInviteCode] = useState('');
	const [apiKey, setApiKey] = useState('');
	const { settingsMenu } = useAdminMenuConstants();
	const [checkValue, setCheckValue] = useState<boolean | null>(null)
	const [bandwidth, setBandwidth] = useState<boolean | null>(true);
	const [selfEnable, setSelfEnable] = useState<boolean | undefined>(false);
	const [enableLoading, setEnableLoading] = useState<boolean | null>(true);

	useEffect(() => {
		fetchSettingApiKey();
		dispatch(setReduxActiveTab('settings'));
	}, []);

	useEffect(() => {	
		fetchNetworkMode();
		fetchSelfRegistration();
	},[])

	const fetchNetworkMode = async () => {
		const data = await dispatch(getbandwidth());
			setCheckValue(data.payload?.networkIssue);
			setBandwidth(false)
	}

	const fetchSettingApiKey = async () => {
		const data = await dispatch(getSettingApiKey());
		setApiKey(data.payload?.openaiApiKey);
		setSettingData(data.payload);
		setInviteCode(data.payload?.client?.inviteCode);
	};

	const fetchSelfRegistration = async () => {
		const data = await dispatch(getSelfRegistration());
		const payload = data?.payload as { active?: boolean };
		setSelfEnable(payload?.active);
		setEnableLoading(false);
	}

	return (
		<div
			style={{
				background: 'var(--card-bg-color)',
				borderRadius: '8px',
				margin: '10px',
				padding: '2px 0px',
			}}>
			<div style={{ margin: '0px 10px 20px' }}>
				<Tabs
					activeKey={activeTab}
					onChange={setActiveTab}
					className="settings-main-menu-tabs"
					items={settingsMenu.map(item => ({
						key: item.key,
						label: item.label,
						children:
							item.key === ACTIVETAB.OPENAI ? (
								<>
									<div className="settings-tab-container">
										{[
											{
												label: t('Admin.data.menu.setting.openAi.label'),
												component: (
													<OpenAiSettings
														{...{ settingData, apiKey, setApiKey }}
													/>
												),
											},
											isSuperAdmin && {
												label: t('Admin.data.theme.themeSelectorText'),
												component: <ThemeSelector isSettings={true} />,
											},
											{
												label: t('Admin.data.theme.inviteCodeText'),
												component: <InviteCodeSettings {...{ inviteCode }} />,
											},
											isSuperAdmin && {
												label: t('Admin.data.theme.bandwithText'),
												component: <BandwidthMode bandwidth={bandwidth} checkValue={checkValue!} setCheckValue={setCheckValue} fetchNetworkMode={fetchNetworkMode} />,
											},
											isSuperAdmin && {
												label: t('Admin.data.theme.selfRegistration'),
												component: <SelfRegistration selfEnable={selfEnable} enableLoading={enableLoading} fetchSelfRegistration={fetchSelfRegistration} />,
											},
										]
											.filter(Boolean)
											.map((item, index) => {
												const validItem = item as {
													label: React.ReactNode;
													component: React.ReactNode;
												};
												return (
														<div key={index} className="settings-tab-card">
															<p className="settings-tab-label">
																{validItem.label}
															</p>
															{validItem.component}
														</div>
												);
											})}
									</div>
								</>
							) : item.key === ACTIVETAB.EXPORT_REPORTS ? (
								<ExportReports />
							) : item.key === ACTIVETAB.TEMPLATES ? (
								<Templates />
							) : item.key === ACTIVETAB.CONTENT_MANAGER ? (
								<ContentManager />
							) : (
								<Features />
							),
					}))}
				/>
			</div>
		</div>
	);
};

export default Settings;
